const { medias } = require('#Configs');

function aspectRatioCalc(aspectRatio, w) {
  let height = Math.floor(w / aspectRatio);
  return 2 * Math.ceil(height / 2);
}

function generateRes(aspectRatio, resArr = []) {
  return resArr.map((w) => ({
    w,
    h: aspectRatioCalc(aspectRatio, w),
  }));
}

function ratioTableGenerator(list = [], w, r, title) {
  return {
    title,
    table: list.map((entry) => {
      const isArr = Array.isArray(entry),
        screenWidth = isArr ? entry[0] : entry,
        mediaWidth = ((isArr && entry[1]) || w) / 100,
        aspectRatio = (isArr && entry[2]) || r,
        width = screenWidth * mediaWidth;

      return [screenWidth, aspectRatioCalc(aspectRatio, width)];
    }),
  };
}

function generateImg(
  src,
  ratioW,
  ratioH,
  sizes = medias.srcsetSizes.mobileFull,
  res = medias.resolutions.all,
  defaultRes = 1920,
  separator = '/'
) {
  return {
    src,
    defaultRes,
    ratioW,
    ratioH,
    sizes,
    res: generateRes(ratioW / ratioH, res),
    separator,
  };
}

function addSource(media, w, h, size = '100vw', set) {
  set = set || medias.resolutions[media];

  return {
    media, // media breakpoint name (mobile|tablet|desktop)
    mediaQuery: medias.mediaQueries[media], // min-width with unit
    set: generateRes(w / h, set), // set of resolutions for this crop
    w, // ratio width
    h, // ratio height
    size, // display size in vw
  };
}

function generatePicture(src, sources, defaultRes = 1920, separator = '/') {
  return {
    src,
    separator,
    defaultRes,
    sources,
  };
}

module.exports = {
  aspectRatioCalc,
  generateRes,
  ratioTableGenerator,
  generateImg,
  addSource,
  generatePicture,
};
